'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ESCAPE = 27;
var callbacks = {};

var handleWindowKeyDown = function handleWindowKeyDown(ev) {
  if (ev.keyCode == ESCAPE) {
    _underscore2.default.last(_underscore2.default.values(callbacks))();
  }
};

exports.default = function (key, callback) {
  if (callback) {
    callbacks[key] = callback;
  } else {
    delete callbacks[key];
  }

  if (_underscore2.default.keys(callbacks).length == 1) {
    window.addEventListener('keydown', handleWindowKeyDown);
  }

  if (_underscore2.default.keys(callbacks).length == 0) {
    window.removeEventListener('keydown', handleWindowKeyDown);
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/onEscape.js
// module id = 624
// module chunks = 0